export default __webpack_public_path__ + "static/6-a9e7051377f4244348096f7c552b20f9.png";